import Api from '@/util/Api'

export default class CustomCombinationApiService {
  
  static store(customCombination) {
    return Api.post(`/api/custom_combinations/store`, customCombination)
      .then(({ data }) => data )
  }
}